import script from "./LicenseWindowHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./LicenseWindowHistory.vue?vue&type=script&setup=true&lang=js"

import "./LicenseWindowHistory.vue?vue&type=style&index=0&id=7bde95ab&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bde95ab"]])

export default __exports__